import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";

@Injectable()
export class Seguimiento_exp_Service {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(private _http: HttpClient) {
        this.url = GLOBAL.url;
    }

    getSolicitudes(rut) {
        let params = {
            rut: rut
        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'seguimiento_expediente', params, { headers: headers })
            .pipe(map((response: any) => response.json()));
    }

    /* getRut(rut, departamento){
         let params = {
             rut: rut, 
             departamento:departamento
            
         };
 
         let headers = new Headers({
             'Content-type': 'application/json',
             'Authorization': sessionStorage.getItem("token-domCloud")
         });
 
         return this._http.post(this.url+'seguimiento_expediente', params, {headers: headers})
         .pipe(map(res => res.json()));
     }*/


    getExp(rut, numero, departamento) {
        let params = {
            rut: rut,
            numero: numero,
            departamento: departamento

        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'seguimiento_solicitud', params, { headers: headers })
            .pipe(map((response: any) => response.json()));
    }

    getActa(exp) {
        let params = {
            exp: exp

        };

        let headers = new HttpHeaders({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'acta_expediente', params, { headers: headers })
            .pipe(map((response: any) => response.json()));
    }

    get_expediente(numSolic, rut): Observable<any> {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })

        let paramas = {
            numSolic: numSolic,
            rut: rut
        }

        //console.log("manda el numsol ", numSolic)
        return this._http.post(this.url + 'exp/get_expediente', paramas, { headers: headers })
            .pipe(map(response => response));
    }



}